import React from "react";
export { calcYearsDeceased } from "../../Utils/family-tree/dateAndTime";

/** Read-only calculated field with grey background. */
export function AddMemberAutoInput({ label, value, name, placeholder = "" }) {
  return (
    <div className="form-group addmember-form-group addmember-field-auto">
      <label>{label}</label>
      <input
        type="text"
        name={name}
        value={value || ""}
        readOnly
        placeholder={placeholder}
        className="addmember-auto-input"
      />
    </div>
  );
}

/** Read-only relation field. */
export function AddMemberAutoRelationField({ label, name, value }) {
  return (
    <div className="form-group addmember-form-group addmember-field-auto">
      <label>{label}</label>
      <input type="text" name={name} value={value || ""} readOnly className="addmember-auto-input" />
    </div>
  );
}
